import type { NewContractType } from "web_myplann/Goals/Types/NewContractType";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { portfolioDomainRegistry } from "web_myplann/Portfolio/Helpers/portfolioDomainRegistry";

export const getNewContractEditPath = (
	type: NewContractType,
	portfolioId: number,
): string =>
	portfolioDomainRegistry[type]?.editRoute(portfolioId) ??
	Routing.Portfolio.PortfolioEditBankProduct.path(portfolioId);
